import { Input } from "@mui/joy";

function TextInput(props) {
  return (
    <Input
      {...props}
      sx={{
        border: 'none',
        borderBottom: `2px solid #D6D6D6`, // COLOR_GRAY
        borderRadius: 0,
        boxShadow: 'none',
        '&:hover, &:focus': {
          borderBottom: `2.5px solid #F0B27A`, // COLOR_PRIMARY
        },
        ...(props.sx || {}),
      }}
    >
      {props.children}
    </Input>
  );
}

export default TextInput;